module.exports = __webpack_public_path__ + "img/Guhemba.e9b3ce93.jpg";